module.exports = __webpack_public_path__ + "img/rewrite.9481afbd.jpg";